import './index.less';
import * as React from 'react';
import { Popover, DotDotDot } from '@beehive/components';
import classnames from 'classnames';

interface DotDotDotPopoverProps {
  value: any;
  height?: number;
  align?: any;
  prefixCls?: any;
}

interface DotDotDotPopoverState {
  visible: boolean;
  dotPopoverWidth: number;
}

class DotDotDotPopover extends React.Component<
  DotDotDotPopoverProps,
  DotDotDotPopoverState
> {
  private currentRef: React.RefObject<any> = React.createRef();
  private containerRef: React.RefObject<any> = React.createRef();

  constructor(props: DotDotDotPopoverProps) {
    super(props);
    this.state = {
      visible: false,
      dotPopoverWidth: 0 ,
    };
  }

  onMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    const dotEle = event && (event.target as HTMLElement);
    if (!dotEle) {
      return;
    }
    const dotEleText = dotEle.innerHTML;
    if (typeof dotEleText !== 'string' || !dotEleText.includes('…')) {
      return;
    }
    const dotEleParent = this.containerRef.current.parentNode as HTMLElement;
    if (!dotEleParent) {
      return;
    }
    const dotEleParentWidth = dotEleParent.getBoundingClientRect().width;
    this.setState({
      visible: true,
      dotPopoverWidth: dotEleParentWidth,
    });
  }

  onMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    setTimeout(() => {
      this.setState({
        visible: false,
      });
    }, 200);
  }

  render() {
    const { value, height, align, prefixCls= '' } = this.props;
    const { visible, dotPopoverWidth } = this.state;
    const classNames = classnames('dot-dot-dot-popover', prefixCls);
    return (
      <span
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        ref={this.containerRef}
      >
        <Popover
          content={value}
          align={{ points: ['tl', 'tl'], ...align }}
          overlayClassName={classNames}
          visible={visible}
          overlayStyle={{ maxWidth: dotPopoverWidth + 24 }}
        >
          <span ref={this.currentRef}>
            <DotDotDot clamp={height || 3} useNativeClamp={false} title="">
              {value}
            </DotDotDot>
          </span>
        </Popover>
      </span>
    );
  }
}

export default DotDotDotPopover;
